// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Region from "common/src/Region.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import Button from "@mui/material/Button";

function WrappedScreenshotButton(Props) {
  var player = Props.player;
  var set = TftSet.useT(undefined);
  var tag = player.tag;
  var tagStr = tag !== undefined ? "/" + tag : "";
  return React.createElement("a", {
              download: "set-wrapped",
              href: "https://u.tft.tools/screenshot/wrapped/" + String(TftSet.num(set)) + "/" + Region.toUrlName(player.region) + "/" + player.playerName + tagStr + "/" + String(player.queueId),
              target: "_blank"
            }, React.createElement(Button, {
                  onClick: (function (param) {
                      
                    }),
                  variant: "contained",
                  color: "secondary",
                  size: "small",
                  children: "Export as image"
                }));
}

var make = WrappedScreenshotButton;

export {
  make ,
  
}
/* react Not a pure module */
